<template>
    <div class="subject  ">
        <div >
            <div class="subject-left-nav">
                <div class="left-nav-header"><span>专题服务</span></div>
                <div class="left-nav-list"> 
                    <!-- 树结构 -->
                    <div class="tree_container">
                        <el-tree
                            :indent="0"
                            class="tree-line"
                            :data="labelList" 
                            :props="defaultProps"
                            :highlight-current="true" 
                            ref="navTree"
                            default-expand-all
                            node-key="id"
                            @node-click="handleNodeClick"
                        >   
                            <span slot-scope="{ data }"> 
                                <i v-if="!data.children " class="el-icon-tickets" />  
                                {{ data.label }}
                            </span>
                        </el-tree> 
                    </div>  
                </div> 
            </div>
        </div> 
        <subjectCont ref="subject_cont" :navList=navList :treeType=treeType></subjectCont> 
    </div>
</template>

<script>
import subjectCont from './comps/subject_cont.vue'
import subjectData from './comps/subjectData.js'
export default {
    components: {
        subjectCont
    },
    data () {
        return { 
            labelList:subjectData.labelList,
			treeType:'',
			navList:[],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            value1: '',
            value2:'', 
        }
    },
    mounted () { 
		this.$nextTick(function () {
			this.$nextTick(() => {
				let treeElement = this.$refs.navTree.$el; // 确保你的树组件有 ref="navTree"
				treeElement.querySelectorAll('[aria-hidden]').forEach(el => {
					el.removeAttribute('aria-hidden');
				});
				// myTree 数组件的ref  默认让第一项高亮 
				// data是树组件对应的数据
				// 通过data中的第一项的id找到对应的节点，然后把这个节点设置为高亮
				this.$refs.navTree.setCurrentKey(this.labelList[0].children[0].id) 
				this.treeType=this.labelList[0].children[0].infoType
				this.navList=this.labelList[0].children[0].navList;
				this.$nextTick(()=>{ 
					this.$refs.subject_cont.nav_click(this.navList[0],0,this.treeType)
				})
			});
		});
    },
    methods: {
        handleNodeClick(data, node ,el) {     
			if(node.level==2){ 
				this.treeType=data.infoType;
				this.navList=[].concat(data.navList?data.navList:[]);
				this.$nextTick(()=>{
					this.$refs.subject_cont.nav_click(this.navList[0],0)
				})
			}
        }, 
    }
}
</script>

<style lang="less" scoped>
@import url('./subject.less'); 
// 树样式
.tree-line{
	::v-deep .el-tree-node{
		position: relative;
		padding-left: 16px; // 缩进量
	}
	::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
		background: red
	}
	::v-deep .el-tree-node__content{
		height: 30px;
		.is-leaf{
			width: 4px;
		} 
	}
	::v-deep .el-tree-node__children{
		padding-left: 16px; // 缩进量
	}
	// 竖线
	::v-deep .el-tree-node::before{
		content:"";
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -24px;
		border-width: 1px;
		border-left: 1px dashed #ccc;
	}
	// 当前层最后⼀个节点的竖线⾼度固定
	::v-deep .el-tree-node:last-child::before{
		height: 38px; // 可以⾃⼰调节到合适数值
	}
	// 横线
	::v-deep .el-tree-node::after{
		content:"";
		width: 24px;
		height: 20px;
		position: absolute;
		left: -3px;
		top: 14px;
		border-width: 1px;
		border-top: 1px dashed #ccc;
	}
	// 去掉最顶层的虚线，放最下⾯样式才不会被上⾯的覆盖了
	& > ::v-deep .el-tree-node::after{
		border-top: none;
	}
	& > ::v-deep .el-tree-node::before{
		border-left: none;
	}
	// 展开关闭的icon
	::v-deep .el-tree-node__expand-icon{
		font-size: 16px;
		// 叶⼦节点（⽆⼦节点）
		::v-deep &.is-leaf{
		color: transparent;
		display: none; // 也可以去掉
		}
	}
}
</style>
